require('./bootstrap');
let moment = require('moment');
moment.locale('pt');
window.Vue = Vue;
window.moment = moment;
window.Vue.prototype.moment = moment;

import VueLazyload from 'vue-lazyload';
import Vue from 'vue';
import VueRouter from 'vue-router';
import router from "./router";
import 'nprogress/nprogress.css';
import {loadProgressBar} from 'axios-progress-bar';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(VueLazyload);
Vue.use(require('vue-moment'));
Vue.use(VueAxios, axios);
Vue.use(VueMeta);
Vue.router = router;
loadProgressBar();


window.Vue = require('vue');

Vue.prototype.trans = (string) => {
    return _.get(window.i18n, string) || string
};

/**
 * Vue app
 * @type {Vue}
 */

Vue.component('app-component', require('./components/AppComponent').default);
Vue.component('geral-list', require('./components/GeralList').default);
Vue.component('image-upload', require('./components/ImageUpload').default);
Vue.component('user-list', require('./components/UserList').default);
Vue.component('pagination', require('laravel-vue-pagination'));

const app = new Vue({
    el: '#app',
    router,
});
